import { Component, ElementRef, Injector, ViewChild } from '@angular/core';

import { ProductType } from '@core/model/enums';

import { WebElementRefInstanceType } from '@model/web-element-ref-instance.type';
import { RefinanceBaseComponent } from '../refinance-base';

@Component({
  selector: 'app-refinance-loan',
  templateUrl: './refinance-loan.component.html',
})
export class RefinanceLoanComponent extends RefinanceBaseComponent {
  @ViewChild('refinanceLoanRef') public refinanceLoanRef: ElementRef;
  public refinanceLoanRefInstance: WebElementRefInstanceType;

  protected get webElementRef(): ElementRef {
    return this.refinanceLoanRef;
  }

  protected set webElementRefInstance(instance: WebElementRefInstanceType) {
    this.refinanceLoanRefInstance = instance;
  }

  protected get productType(): ProductType {
    return ProductType.RETRP;
  }

  constructor(injector: Injector) {
    super(injector);
  }
}
